fccd-location-search {
  .mapbox-geolocation {
    position: relative;
    z-index: 8;

    .autocomplete-container ul {
      position: absolute;
      /*
      Tried to avoid throwing in a random number for top padding below but there was no elegant way to do this given the structure of geo-location input component.
      The component is combination of two sub components. Given that we need the autocomplete option displayed right after the first sub component, we had manually
      pull the autocomplete options to the top with below number.
      */
      top: 67%;
      left: 0;
      right: 0;
      box-shadow: var(--elevation-high-h-offset) var(--elevation-high-v-offset) var(--elevation-high-blur) var(--color-elevation);
      margin: 0;
      padding: 0;
    }
    .autocomplete-container li {
      padding-right: var(--spacing-sm);
      padding-left: var(--spacing-sm);
      padding-top: var(--spacing-xs);
      padding-bottom: var(--spacing-xs);
      background-color: var(--color-neutral-xxlight);
      border: 1px solid var(--color-neutral-base);
      list-style: none;
      margin-top: 0;
    }
    .autocomplete-focus,
    .autocomplete-container li:hover {
      cursor: default;
      background-color: var(--color-neutral-xlight) !important;
      color: var(--color-link-dark);
    }
  }
}
